import { defineMessages } from 'react-intl';

export default defineMessages({
  filterLanguagePlaceholder: {
    id: 'frontbucket.profile.repositories.filter.languages',
    description:
      'Placeholder text for a filter for showing repositories with the selected language',
    defaultMessage: 'Language',
  },
  filterLanguageLoading: {
    id: 'frontbucket.profile.repositories.filter.languages.loading',
    description:
      'Message shown in the language filter when it is loading the initial options',
    defaultMessage: 'Loading...',
  },
  filterLanguageAll: {
    id: 'frontbucket.profile.repositories.filter.languages.all',
    description: 'Option for select all languages',
    defaultMessage: 'All',
  },
  filterNoOptions: {
    id: 'frontbucket.profile.repositories.filter.language.empty',
    description:
      'The message displayed in the language filter when no languages are found',
    defaultMessage: "Couldn't get the list of languages",
  },
  filterError: {
    id: 'frontbucket.profile.repositories.filter.language.error',
    description:
      'The message displayed in the language filter when the languages are failed to load',
    defaultMessage:
      'We couldn’t get the list of languages. Try refreshing the page.',
  },
});
